import { render, staticRenderFns } from "./Myfeedbacks.vue?vue&type=template&id=4de84e3a"
import script from "./Myfeedbacks.vue?vue&type=script&lang=js"
export * from "./Myfeedbacks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports